/* eslint-disable */
export default {
  _work_area_bg: 'work-area-bg',
  _color_select_open_bg: 'color-select-open-bg',
  _menu_bg: 'menu-bg',
  _color_select_bg: 'color-select-bg',
  _size_select_bg: 'size-select-bg',
  _menu_btn_base: 'menu-btn-base',
  _draw_btn_active: 'draw-btn-active',
  _eraser_btn_active: 'eraser-btn-active',
  _fill_btn_active: 'fill-btn-active',
  _grid_btn: 'grid-btn',
  _draw_btn: 'draw-btn',
  _eraser_btn: 'eraser-btn',
  _picker_bg: 'picker-bg',
  _fill_btn: 'fill-btn',
  _grid_btn_eye_closed: 'grid-btn-eye-closed',
  _menu_btn: 'menu-btn',
  _undo_btn: 'undo-btn',
  _grid_btn_eye: 'grid-btn-eye',
  _color_select_arrow: 'color-select-arrow',
}